export default __webpack_public_path__ + "static/media/icon apps-add.d17752b2.svg";